import { render, staticRenderFns } from "./taxi.vue?vue&type=template&id=0f212380&scoped=true&"
import script from "./taxi.vue?vue&type=script&lang=js&"
export * from "./taxi.vue?vue&type=script&lang=js&"
import style0 from "./taxi.vue?vue&type=style&index=0&id=0f212380&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f212380",
  null
  
)

export default component.exports